import { render, staticRenderFns } from "./ProductListingCompactCardRevamp.vue?vue&type=template&id=5bb83ddc&scoped=true"
import script from "./ProductListingCompactCardRevamp.vue?vue&type=script&lang=js"
export * from "./ProductListingCompactCardRevamp.vue?vue&type=script&lang=js"
import style0 from "./ProductListingCompactCardRevamp.vue?vue&type=style&index=0&id=5bb83ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb83ddc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReusableLink: require('/app/components/common/ReusableLink.vue').default,ToggleFavouriteProduct: require('/app/components/products/product-components/ToggleFavouriteProduct.vue').default,SponsorPromotion: require('/app/components/products/product-components/SponsorPromotion.vue').default,ProductShortcut: require('/app/components/products/product-components/ProductShortcut.vue').default,ProductFeatureCompact: require('/app/components/products/product-components/ProductFeatureCompact.vue').default,ProductScore: require('/app/components/products/product-components/ProductScore.vue').default,ProductKeyItem: require('/app/components/products/product-components/ProductKeyItem.vue').default,ProductPriceItem: require('/app/components/products/product-listing/ProductPriceItem.vue').default,ReusableButton: require('/app/components/common/ReusableButton.vue').default,ComparisonButton: require('/app/components/products/comparison/ComparisonButton.vue').default})
